import { ICandidate } from '../types/bullhorn/candidate';
import { IJobOrder } from '../types/bullhorn/job-order';
import { IJobSubmission } from '../types/bullhorn/job-submission';
import { IClientContact } from '../types/bullhorn/client-contact';
import { IClientCorporation } from '../types/bullhorn/client-corporation';
import { IOpportunity } from '../types/bullhorn/opportunity';
import { INote } from '../types/bullhorn/note';

export class BullhornEntityCollection {
  private _Candidate!: ICandidate[] | [];
  private _JobOrder!: IJobOrder[] | [];
  private _JobSubmission!: IJobSubmission[] | [];
  private _ClientContact!: IClientContact[] | [];
  private _ClientCorporation!: IClientCorporation[] | [];
  private _Opportunity!: IOpportunity[] | [];
  private _Note!: INote[] | [];

  constructor() {
    this.candidates = [];
    this.jobOrders = [];
    this.jobSubmissions = [];
    this.clientContacts = [];
    this.clientCorporations = [];
    this.opportunities = [];
    this.notes = [];
  }

  get candidates(): ICandidate[] {
    return this._Candidate;
  }

  set candidates(value: ICandidate[]) {
    this._Candidate = value;
  }

  get jobOrders(): IJobOrder[] {
    return this._JobOrder;
  }

  set jobOrders(value: IJobOrder[]) {
    this._JobOrder = value;
  }

  get jobSubmissions(): IJobSubmission[] {
    return this._JobSubmission;
  }

  set jobSubmissions(value: IJobSubmission[]) {
    this._JobSubmission = value;
  }

  get clientContacts(): IClientContact[] {
    return this._ClientContact;
  }

  set clientContacts(value: IClientContact[]) {
    this._ClientContact = value;
  }

  get clientCorporations(): IClientCorporation[] {
    return this._ClientCorporation;
  }

  set clientCorporations(value: IClientCorporation[]) {
    this._ClientCorporation = value;
  }

  get opportunities(): IOpportunity[] {
    return this._Opportunity;
  }

  set opportunities(value: IOpportunity[]) {
    this._Opportunity = value;
  }

  get notes(): INote[] {
    return this._Note;
  }

  set notes(value: INote[]) {
    this._Note = value;
  }
}
